var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0351 3.19312H7.15773C6.47661 3.19312 5.92456 2.64116 5.92456 1.96014C5.92456 1.27913 6.47661 0.727173 7.15773 0.727173H10.0351C10.7163 0.727173 11.2683 1.27913 11.2683 1.96014C11.2683 2.64116 10.7163 3.19312 10.0351 3.19312Z",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98536 3.25309H7.1251C6.44804 3.25309 5.89928 2.70433 5.89928 2.02727C5.89928 1.83329 5.94432 1.64984 6.02452 1.48682H4.10926C3.06045 1.48682 2.01772 2.39709 2.01772 3.64319L2.01758 14.108C2.01758 15.3698 3.00964 16.287 4.18171 16.287H12.9901C14.3182 16.287 15.1753 15.2408 15.1753 14.108V3.63879C15.1753 2.526 14.2791 1.48682 13.0264 1.48682H11.0859C11.1661 1.64984 11.2112 1.83329 11.2112 2.02727C11.2112 2.70433 10.6624 3.25309 9.98536 3.25309ZM5.47358 9.54379L7.15605 11.2289C7.38403 11.4572 7.75401 11.4573 7.98206 11.229L11.7059 7.50199C11.9539 7.25376 11.948 6.84973 11.6929 6.60885C11.4477 6.37743 11.0629 6.38308 10.8247 6.62159L7.56898 9.88073L6.5091 8.82252L6.35123 8.66522C6.10132 8.41622 5.69443 8.4252 5.45575 8.68497C5.23077 8.92984 5.23863 9.30848 5.47358 9.54379Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.aa77b00a3d4c75b46732443791478a1b.svg";
export { ForwardRef as ReactComponent };